import React from 'react'
import { Panel, TextFieldIcon, PhoneFieldIcon } from '../../../_components'

export default function NextOfKin( { tag, details, setNOKPhone, values, handleChange, handleBlur } ) {
  return (
    <Panel label="Next of Kin">
        <div className="grid md:grid-cols-2 md:gap-2 lg:grid-cols-3 lg:gap-3">
            <TextFieldIcon 
                name="nok_firstname"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.nok_firstname}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={true}
                label="First Name"
                question="Next of Kin First Name"
            />

            <TextFieldIcon 
                name="nok_lastname"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.nok_lastname}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                label="Last Name"
                required={true}
                question="Next of Kin Last Name"
            />

            <TextFieldIcon 
                name="nok_other"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.nok_other}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                label="Other Name"
                required={false}
                question="Next of Kin Other Name"
            />

            <TextFieldIcon 
                name="relationship"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.relationship}
                label="Relationship"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={true}
                question="Relationship"
            />

            <PhoneFieldIcon 
                tag={tag}
                editValue={details?.nok_phone}
                name="nok_phone"
                handleChange={handleChange}
                handleBlur={handleBlur}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                callback={ ( phone ) => {
                    setNOKPhone( phone )
                } }
                question="Next of Kin Phone Number"
            />
        </div>
    </Panel>
  )
}
